import React, { useCallback } from 'react';

import { FormField } from '@gogame/form';
import { useChildComponent } from '@gogame/hooks-ts';

import { CreateConceptFamilyForm } from 'scenes/Gallery/GalleryPage/ConceptFamilies/ConceptFamilyForm';
import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/constants';
import { loadConceptFamilies } from 'scenes/Gallery/GalleryPage/Concepts/sources/fields';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

const ConceptFamiliesMultiSelect = () => {
  const [childComponent, openChildComponent] = useChildComponent();
  const { isAllowManageConceptFamilies } = useGalleryPermissions();
  const handleAdd = useCallback(async () => {
    return await new Promise((resolve, reject) => {
      openChildComponent(CreateConceptFamilyForm, {
        onClose: reject,
        onSubmit: resolve,
      });
    });
  }, [openChildComponent, CreateConceptFamilyForm]);

  return (
    <React.Fragment>
      <FormField.MultiSelect
        label={'Concept families'}
        name={CONCEPT.CONCEPT_FAMILIES}
        source={loadConceptFamilies}
        onAdd={isAllowManageConceptFamilies ? handleAdd : null}
        addOptionLabel={
          isAllowManageConceptFamilies ? 'Add Concept Family' : null
        }
        padding={0}
      />
      {childComponent}
    </React.Fragment>
  );
};
export default ConceptFamiliesMultiSelect;
